import { useCallback } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { RatingsPage } from "@/components/ratings/ratings-page";
import { parseRatingsSearch, type RatingsSearch } from "@/components/ratings/search";

export const Route = createFileRoute("/_app/$workspaceSlug/$projectSlug/ratings")({
  // The filters live in the URL and nowhere else. Whatever the URL says,
  // this returns a page that can be drawn: it never throws.
  validateSearch: (search: Record<string, unknown>): RatingsSearch => parseRatingsSearch(search),
  component: RatingsRoute,
});

function RatingsRoute() {
  const { projectSlug } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const setSearch = useCallback(
    (next: RatingsSearch) => void navigate({ search: next, replace: true }),
    [navigate],
  );
  // Keyed by project: the filters are one project's.
  return <RatingsPage key={projectSlug} search={search} onSearchChange={setSearch} />;
}
